/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "trash-can",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666666"
            },
            "trashCan": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "50.3",
            "height": "68.4"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "-280 362.6 50.3 68.4", className: "trash-can", width: this.props.width, height: this.props.height, style: this.props.trashCan },
            _react2["default"].createElement("path", { className: "st0", d: "M-243.9 369.1h11.9c1.3 0 2.3 1 2.3 2.3v4.8H-280v-4.8c0-1.3 1-2.3 2.3-2.3h11.8v-4.2c0-1.3 1-2.3 2.3-2.3h17.4c1.3 0 2.3 1 2.3 2.3v4.2zM-265.6 431H-235.4c1.4 0 2.6-1.2 2.6-2.6v-48.5h-44v48.5c0 1.4 1.2 2.6 2.6 2.6h8.6zm19-7.1c-1.4 0-2.6-1.2-2.6-2.6v-31.7c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6v31.7c0 1.4-1.2 2.6-2.6 2.6zM-263 387c1.4 0 2.6 1.2 2.6 2.6v31.7c0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6v-31.7c0-1.4 1.1-2.6 2.6-2.6z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/trash-can.js